import { SpecialOfferBadge } from './badge/SpecialOfferBadge';
import { NessProductBadge } from './const';

const BadgeClassMap = {
  SpecialOffer: SpecialOfferBadge,
} as const;

type BadgeClassTypeMap = {
  [K in keyof typeof BadgeClassMap]: InstanceType<(typeof BadgeClassMap)[K]>;
};

export class NessProductBadgeFactory {
  static readonly Type = NessProductBadge;

  static create<Type extends keyof BadgeClassTypeMap>(
    type: Type,
    props: {
      klass: string;
    },
  ): BadgeClassTypeMap[Type] {
    const BadgeClass = BadgeClassMap[type];

    if (!BadgeClass) {
      throw new Error(`지원되지 않는 뱃지 타입: ${type}`);
    }

    return new BadgeClass(props);
  }
}
